export const sidebarLinkStyles = [
  'group',
  'h-8 gap-3 rounded-lg px-3',
  'bg-[var(--ub-sidebar-link-bg)] text-[var(--ub-sidebar-link-c)]',
  'hover:bg-[var(--ub-sidebar-link-hover-bg)]',
  'data-[active=true]:bg-[var(--ub-sidebar-link-active-bg)]',
  'data-[active=true]:hover:bg-[var(--ub-sidebar-link-active-bg)]',
  'data-[active=true]:font-semibold',
  'data-[active=true]:text-[var(--ub-sidebar-link-active-c)]',
  'data-[active=true]:hover:text-[var(--ub-sidebar-link-active-c)]',
  '[&_i]:flex [&_i]:size-4 [&_i]:items-center [&_i]:justify-center [&_i_svg]:size-4',
].join(' ');

export const adminLinkStyles = [
  'h-8 gap-3 rounded-lg px-3',
  'bg-[var(--ub-sidebar-link-bg)] text-[var(--ub-sidebar-link-c)]',
  'hover:bg-[var(--ub-sidebar-link-hover-bg)]',
  '[&_i]:flex [&_i]:size-4 [&_i]:items-center [&_i]:justify-center [&_i_svg]:size-4',
].join(' ');
